

type NullableString = string | null;
type NullableBoolean = boolean | null;

type NullableDateTime =  Date |null;

export type SocItemDetailsOfqual = {
  socId: NullableString;
  modifiedDate: NullableDateTime;
  modifiedByUPN: NullableString;
  modifiedByDisplayName: NullableString;
  assignedToDisplayName: NullableString;
  agreeWithAoCurrentComplianceDeclaration: NullableBoolean;
  agreeWithAoFutureComplianceDeclaration: NullableBoolean;
  reasonsForDisagreementWithComplianceDeclaration: SocReasonsForDisagreement | null;
  reasonsForDisagreementDescription: NullableString;
  complianceRagRating: SocItemRagStatus | null;
  complianceClosureStatus: SocItemClosureStatus | null;
  complianceFollowUp: SocItemFollowUp | null;
  complianceFollowUpStatus: SocItemFollowUpStatus | null;
  kloeOneRagRating: SocItemRagStatus | null;
  kloeOneFollowUp: SocItemFollowUp | null;
  kloeOneFollowUpStatus: SocItemFollowUpStatus | null;
  kloeOneLead: NullableString;
  kloeOneClosureStatus: SocItemClosureStatus | null;
  kloeTwoRagRating: SocItemRagStatus | null;
  kloeTwoFollowUp: SocItemFollowUp | null;
  kloeTwoFollowUpStatus: SocItemFollowUpStatus | null;
  kloeTwoLead: NullableString;
  kloeTwoClosureStatus: SocItemClosureStatus | null;
  kloeThreeRagRating: SocItemRagStatus | null;
  kloeThreeFollowUp: SocItemFollowUp | null;
  kloeThreeFollowUpStatus: SocItemFollowUpStatus | null;
  kloeThreeLead: NullableString;
  kloeThreeClosureStatus: SocItemClosureStatus | null;
  overallRagRating: SocItemRagStatus | null;
  overallFollowUpLead: socItemOverallFollowUpLead | null;
  overallClosingStatus: SocItemClosureStatus | null;
  overallClosingRationale: SocItemClosureRationale | null;
};

  export const requiredOfqualFields: (keyof SocItemDetailsOfqual)[] = [
  "socId",
  "modifiedDate",
  "modifiedByUPN",
  "modifiedByDisplayName",
  "assignedToDisplayName",
  "agreeWithAoCurrentComplianceDeclaration",
  "agreeWithAoFutureComplianceDeclaration",
  "reasonsForDisagreementWithComplianceDeclaration",
  "complianceRagRating",
  "complianceClosureStatus",
  "complianceFollowUp",
  "complianceFollowUpStatus",
  "kloeOneRagRating",
  "kloeOneFollowUp",
  "kloeOneFollowUpStatus",
  "kloeOneLead",
  "kloeOneClosureStatus",
  "kloeTwoRagRating",
  "kloeTwoFollowUp",
  "kloeTwoFollowUpStatus",
  "kloeTwoLead",
  "kloeTwoClosureStatus",
  "kloeThreeRagRating",
  "kloeThreeFollowUp",
  "kloeThreeFollowUpStatus",
  "kloeThreeLead",
  "kloeThreeClosureStatus",
  "overallRagRating",
  "overallFollowUpLead",
  "overallClosingStatus",
  "overallClosingRationale",
  ];


export const defaultSocItemValues: SocItemDetailsOfqual = {
  socId: "",
  modifiedDate: new Date(),
  modifiedByUPN: "",
  modifiedByDisplayName: "",
  assignedToDisplayName: "",
  agreeWithAoCurrentComplianceDeclaration: null,
  agreeWithAoFutureComplianceDeclaration: null,
  reasonsForDisagreementWithComplianceDeclaration: null,
  reasonsForDisagreementDescription: "",
  complianceRagRating: null,
  complianceClosureStatus: null,
  complianceFollowUp: null,
  complianceFollowUpStatus: null,
  kloeOneRagRating: null,
  kloeOneFollowUp: null,
  kloeOneFollowUpStatus: null,
  kloeOneLead: null,
  kloeOneClosureStatus: null,
  kloeTwoRagRating: null,
  kloeTwoFollowUp: null,
  kloeTwoFollowUpStatus: null,
  kloeTwoLead: null,
  kloeTwoClosureStatus: null,
  kloeThreeRagRating: null,
  kloeThreeFollowUp: null,
  kloeThreeFollowUpStatus: null,
  kloeThreeLead: null,
  kloeThreeClosureStatus: null,
  overallRagRating: null,
  overallFollowUpLead: null,
  overallClosingStatus: null,
  overallClosingRationale: null,
};

export enum SocItemRagStatus
{
    Green = 1,
    GreenAmber = 2,
    Amber = 3,
    AmberRed = 4,
    Red = 5
}

export enum SocItemFollowUp
{
    ConsiderReviewInSix = 1,
    FollowUpInternally = 2,
    FollowUpQuestionsAo = 3,
    FollowUpMeetingAo = 4,
    NoFollowUpAction = 5,
    ReferToLegal = 6
}

export enum SocItemFollowUpStatus
{
    FollowUpComplete = 1,
    FollowUpNotRequired = 2,
    FollowUpNotStarted = 3,
    FollowUpStarted = 4
}

export enum SocItemClosureStatus
{
    Strong = 1,
    Medium = 2,
    Weak = 3
}

export enum SocItemClosureRationale
{
    NoActionRequired = 1,
    ConcernsManagedThruBAU = 2,
    ConcernsFullyAddressed = 3
}

export enum socItemOverallFollowUpLead
{
    Ofqual = 1,
    CCEA = 2,
    QW = 3
}

export enum SocReasonsForDisagreement
{
    CurrentRegulatoryAction = 1,
    DeclaredNonComplianceInError = 2,
    OngoingConcerns = 3,
    Other =4
}